import { defineComponent as _defineComponent } from 'vue'
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { IconSlug } from '@/v2/components/ui/icon/iconMap'
import { ValidationProvider } from 'vee-validate'
import AppIcon from '../../ui/icon/AppIcon.vue'
import { vMaska } from 'maska/vue'
import { computed, onMounted, ref, reactive, watch } from 'vue'
import AppLabel from '../label/AppLabel.vue'
import { LabelDialog } from '../label/_types'
import { useElementBounding } from '@vueuse/core'
import { MaskInputOptions } from 'maska'


export default /*#__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
  label: null,
  labelDialog: null,
  name: null,
  type: { default: 'text' },
  disabled: { type: Boolean, default: false },
  hint: null,
  rules: { default: '' },
  clearable: { type: Boolean, default: false },
  prependIcon: null,
  appendIcon: null,
  placeholder: null,
  ignoreErrors: { type: Boolean, default: false },
  tooltip: { type: Boolean, default: false },
  isHintError: { type: Boolean, default: false },
  prefix: null,
  suffix: null,
  min: null,
  max: null,
  mask: null,
  validationMode: { default: 'aggressive' },
  value: null
},
  emits: ["change", "cleared", "enter", "blur", "paste", "click:append", "input"],
  setup(__props, { expose, emit }) {

const props = __props;



const inputRef = ref<HTMLInputElement>()



const options = reactive<MaskInputOptions>({
  mask: props.mask,
  tokens: {
    A: { pattern: /[1-9]/ },
  },
})

const { modelValue } = __MACROS_useVModel(["modelValue", "value", "input"])

function clear() {
  modelValue.value = null
  emit('cleared')
}

const isRequired = computed(() => props.rules.includes('required'))

const hasAppend = computed(() => props.clearable || !!props.suffix || !!props.appendIcon)
const appendIconHover = ref<boolean>(false)
const appendRef = ref<HTMLDivElement | null>(null)
const appendRefRect = useElementBounding(appendRef, {})
const appendWidth = ref(0)
const appendPadding = computed(() => {
  if (appendWidth.value === 0) {
    return 0
  }

  return 8 + appendWidth.value
})
watch(appendRefRect.width, (val) => {
  appendWidth.value = val ?? 0
})

onMounted(() => {
  appendWidth.value = appendRefRect.width.value ?? 0
})

const hasPrepend = computed(() => !!props.prefix || !!props.prependIcon)
const prependRef = ref<HTMLDivElement | null>(null)
const prependRefRect = useElementBounding(prependRef, {})
const prependWidth = ref(0)
const prependPadding = computed(() => {
  if (prependWidth.value === 0) {
    return 0
  }

  return 8 + prependWidth.value
})
watch(prependRefRect.width, (val) => {
  prependWidth.value = val ?? 0
})

onMounted(() => {
  prependWidth.value = prependRefRect.width.value ?? 0
})

watch(modelValue, () => {
  emit('change', modelValue.value)
})

const validationProviderRef = ref<InstanceType<typeof ValidationProvider>>()

expose({
  validate: () => validationProviderRef.value!.validate(),
  errors: () => validationProviderRef.value!.errors,
  setErrors: (errors: string[]) => validationProviderRef.value!.setErrors(errors),
  focus: () => {
    inputRef.value?.focus()
  },
  reset: () => validationProviderRef.value?.reset(),
})

return { __sfc: true,props, inputRef, emit, options, modelValue, clear, isRequired, hasAppend, appendIconHover, appendRef, appendRefRect, appendWidth, appendPadding, hasPrepend, prependRef, prependRefRect, prependWidth, prependPadding, validationProviderRef, ValidationProvider, AppIcon, vMaska, AppLabel }
}

})